export function fmtDate(d: Date) {
  return d.toISOString().split('T')[0];
}

export function fmtDisplayDate(iso?: string) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function fmtDisplayDateTime(iso?: string) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Safely coerce API values (string | number | nested object) to display text. */
export function asDisplayText(value: unknown, fallback = ''): string {
  if (value == null) return fallback;
  if (typeof value === 'string') return value.trim() || fallback;
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  if (typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    const nested =
      obj.name ??
      obj.campaignName ??
      obj.title ??
      obj.label ??
      obj.message ??
      obj.description ??
      obj._id ??
      obj.id ??
      obj.transactionId ??
      obj.paymentId ??
      obj.razorpayPaymentId;
    if (nested != null && nested !== value) {
      return asDisplayText(nested, fallback);
    }
  }
  return fallback;
}

export function asOptionalText(value: unknown): string | undefined {
  const text = asDisplayText(value);
  return text || undefined;
}


export type TransactionReason =
  | 'campaign_payment'
  | 'admin_topup'
  | 'settlement'
  | 'refund'
  | 'tax_payment'
  | 'other'
  | 'deposit_to_wallet_manual'
  | 'commission_payment'
  | 'wallet_to_wallet'
  | 'topup_transfer'
  | 'settlement_deduction'
  | 'waitlist_gift'
  | 'settlement_rollback';

export function reasonConvertor(reason: TransactionReason) {
  switch (reason) {
    case 'campaign_payment':
      return 'Spent';

    case 'admin_topup':
      return 'Topup';

    case 'settlement':
      return 'Withdraw';

    case 'refund':
      return 'Refund';

    case 'other':
      return 'Other';

    case 'deposit_to_wallet_manual':
      return 'Deposit';

    case 'wallet_to_wallet':
      return 'Qndt Amount';

    case 'settlement_rollback':
      return 'Reversed';

    default:
      return reason;
  }
}
